import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Users, DollarSign, Coffee, Utensils, Globe, Smile, Shield, Clock, Star } from 'lucide-react';
import BackButton from '../components/BackButton';
import { useLanguage } from '../contexts/LanguageContext';

const OurPhilosophy = () => {
  const { t } = useLanguage();

  const philosophyPoints = [
    {
      icon: Heart,
      title: t('philosophy.moreThanDating.title'),
      description: t('philosophy.moreThanDating.description')
    },
    {
      icon: Users,
      title: t('philosophy.genuineConnections.title'),
      description: t('philosophy.genuineConnections.description')
    },
    {
      icon: DollarSign,
      title: t('philosophy.costEffective.title'),
      description: t('philosophy.costEffective.description')
    },
    {
      icon: Coffee,
      title: t('philosophy.casualComfortable.title'),
      description: t('philosophy.casualComfortable.description')
    },
    {
      icon: Globe,
      title: t('philosophy.culturalExchange.title'),
      description: t('philosophy.culturalExchange.description')
    },
    {
      icon: Utensils,
      title: t('philosophy.diverseDining.title'),
      description: t('philosophy.diverseDining.description')
    },
    {
      icon: Shield,
      title: t('philosophy.safetyFirst.title'),
      description: t('philosophy.safetyFirst.description')
    },
    {
      icon: Clock,
      title: t('philosophy.flexibleScheduling.title'),
      description: t('philosophy.flexibleScheduling.description')
    },
    {
      icon: Star,
      title: t('philosophy.qualityOverQuantity.title'),
      description: t('philosophy.qualityOverQuantity.description')
    },
    {
      icon: Smile,
      title: t('philosophy.inclusiveCommunity.title'),
      description: t('philosophy.inclusiveCommunity.description')
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center space-x-4 mb-8">
        <BackButton />
        <h1 className="text-3xl font-bold text-gray-900">{t('philosophy.title')}</h1>
      </div>

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl p-8 mb-12 text-white">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">
          {t('philosophy.subtitle')}
        </h2>
        <p className="text-lg opacity-90">
          {t('philosophy.description')}
        </p>
      </div>

      {/* Philosophy Points */}
      <div className="grid md:grid-cols-2 gap-8">
        {philosophyPoints.map((point, index) => (
          <div 
            key={index}
            className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow transform hover:-translate-y-1 duration-300"
          >
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-orange-100 rounded-lg">
                <point.icon className="h-6 w-6 text-orange-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {point.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-12 bg-gray-50 rounded-xl p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {t('philosophy.joinCta')}
        </h2>
        <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
          {t('philosophy.joinDescription')}
        </p>
        <Link
          to="/register"
          className="inline-block bg-orange-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-orange-600 transition"
        >
          {t('philosophy.getStarted')}
        </Link>
      </div>
    </div>
  );
};

export default OurPhilosophy;